import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSWholeWheatEnglishMuffinsProduct from 'models/BSWholeWheatEnglishMuffinsProduct'
import BSWholeWheatEnglishMuffinsPackage from './BSWholeWheatEnglishMuffinsPackage'

const productOptions = {
  packagingInfo: <BSWholeWheatEnglishMuffinsPackage />,
  productTitle: 'Brand Specific Whole Wheat English Muffins',
  model: BSWholeWheatEnglishMuffinsProduct,
  validCategories: ['16'],
  validSubCategories: ['011BS'],
  brandSpecific: true,
}

const BSWholeWheatEnglishMuffins = () => (
  <ProductForm product={productOptions} />
)

export default BSWholeWheatEnglishMuffins
